module.exports = __webpack_public_path__ + "img/cs.5f3ed978.svg";